export const getUserRole = (isSelect) => (isSelect ? 'select' : 'customer');
const USER_TIER_TYPES = {
  CLUB: 'CLUB',
};
const EXPIRED = 'expired';

export const getSubscriptionState = (subscriptions) =>
  subscriptions && subscriptions.live && subscriptions.live.length
    ? subscriptions.live[0].state
    : EXPIRED;

export const isSubscriptionExpired = (subscriptions) =>
  getSubscriptionState(subscriptions) === EXPIRED;

export const isClubMember = (userData) => userData && userData.tier === USER_TIER_TYPES.CLUB;
